import { Component, Vue } from 'vue-property-decorator';
import { sortBy, isNil } from 'lodash';
import { BaseCubeMember } from '@cubejs-client/core';
@Component
export default class QueryBuilderMixin extends Vue {
	filterAndMapFields(items: BaseCubeMember[], genericFieldsDictionary) {
		const toShowList = ['Dim_DataSegregation.companyCode', 'Dim_DataSegregation.companyBusinessName', 'Dim_DataSegregation.siteCode', 'Dim_DataSegregation.siteBusinessName'];

		return sortBy(items
			.filter(d => {
				const isSelectable = !_.isNil(d.meta) && !_.isNil(d.meta.isSelectable) ? d.meta.isSelectable : true;
				if (!isSelectable)
					return false;

				return (!d.name.includes('.gen') && !d.name.startsWith('Dim_DataSegregation'))
					|| (d.name.includes('.gen') && genericFieldsDictionary[d.name])
					|| (d.name.startsWith('Dim_DataSegregation') && toShowList.includes(d.name));					
			})
			.map(d => {
				const caption = this.$t(d.name);
				return {
					...d,
					caption,
					captionCode: d.name
				};
			}), itm => itm.caption);
	}

	availableMeasuresFiltered(availableMeasures, genericFieldsDictionary) {
		return this.filterAndMapFields(availableMeasures, genericFieldsDictionary);
	}
}
